import { render, staticRenderFns } from "./WarningsMenu.vue?vue&type=template&id=f1216876&"
import script from "./WarningsMenu.vue?vue&type=script&lang=js&"
export * from "./WarningsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports